import React, { useState, useEffect, useContext, useRef } from "react";
import { css } from "@emotion/react";

import LoadingAnimation from "../images/loading-animation.gif";
import { baseColor2 } from "../styles/color";
import { UserContext } from "../context/user";

const Overlay = () => {
  const user = useContext(UserContext);
  // App is loading if we don't know the auth state
  const [isLoading, setIsLoading] = useState(user === undefined);
  const [isFading, setIsFading] = useState(false);
  const isMounted = useRef(true);

  const overlayStyles = css`
    position: fixed;
    width: 100vw;
    height: 100vh;
    display: grid;
    place-items: center;
    background-color: ${baseColor2};
    z-index: 100;
    transition: opacity 300ms ease-out 0s;
    opacity: ${isFading ? "0" : "100"};
  `;

  useEffect(() => {
    // Check every second to see if the auth state changed
    const authInterval = setInterval(() => {
      // If we know auth state, don't remove overlay until the
      // animation makes a smooth transition away
      if (user !== undefined && isLoading && isMounted.current) {
        // This triggers fade out
        setIsFading(true);
        setTimeout(() => {
          clearInterval(authInterval);
          // Say loading is complete at end of opacity change
          setIsLoading(false);
        }, 500);
      }
    }, 1000);
  });

  // Update the mounted status if user navigates away
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Hide the logo when we fade out (looks odd otherwise)
  const animation = isFading ? null : (
    <img src={LoadingAnimation} height="48" width="48" alt="" />
  );

  return isLoading ? <div css={overlayStyles}>{animation}</div> : null;
};

export default Overlay;
